exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shop_banner[data-v-cb177164]{padding:30px}.top_exp[data-v-cb177164]{margin-bottom:20px}\n", ""]);

// exports
